<template>
    <div class="container">
        <div class="container-body">
            <div class="container-body-box" v-if="finished">
                <div class="scroll" v-watermark>
                    <div class="header">
                        <div class="header-box">{{ onDateTime(detail.createTime) }}</div>
                    </div>
                    <div class="form">
                        <div class="form-item">
                            <div class="form-item-box">
                                <div class="item">
                                    <div class="label">用药周期：</div>
                                    <div class="value">{{ detail.medicationPeriod == 5 ? `${detail.mpValue}天` :
                                        `${optionsName(medicationPeriod, detail.medicationPeriod, 'remark', 'key')}天` ||
                                        '无' }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">临床诊断：</div>
                                    <div class="value">{{ detail.diagnose || '无' }}</div>
                                </div>
                                <div class="item">
                                    <div class="label">医嘱：</div>
                                    <div class="value">{{ detail.advice || '无' }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="itm" v-for="(itm, idx) in detail.prescriptionList" :key="idx">
                                <div class="itm-head">
                                    <div class="name">{{ itm.drugName }}<span v-show="itm.decoctionName">（{{ itm.decoctionName }}）</span></div>
                                    <div class="unit" v-show="detail.orderMainStatus==1">
                                        <!-- <span>{{ itm.drugSpecifications }}&nbsp;&nbsp;</span> -->
                                        <!-- <span>{{ itm.quantity }}{{ itm.dosageUnitName }}</span> -->
                                        <span>{{ askDrugPackCount(itm).name }}</span>
                                    </div>
                                </div>
                                <div class="itm-foot" v-if="detail.type != 2">
                                    <span class="cell">{{ itm.dosage }}{{ itm.dosageUnitName }}</span>
                                    <span class="cell">{{ itm.frequencyName }}</span>
                                    <span class="cell">{{ itm.drugUsageName }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="detail.type == 2">
                    <div class="total">
                    <span>药品总额：</span>
                    <span class="price">{{ detail.platformMedicineFee }}元</span>
                </div>
                <div class="total">
                    <span>代煎费：</span>
                    <span class="price">{{ detail.platformFriedFee }}元</span>
                </div>
                <div class="total">
                    <span>物流费：</span>
                    <span class="price">{{ detail.platformLogisticsFee }}元</span>
                </div>
                <div class="total">
                    <span>总计：</span>
                    <span class="price">{{ detail.totalFee }}元</span>
                </div>
                </div>
            </div>
            <div class="container-body-box" v-else-if="!loading">
                <van-empty description="加载失败" />
            </div>
        </div>
        <div class="container-btn">
            <van-button type="info" @click="$router.back()">关闭</van-button>
        </div>
    </div>
</template>
<script>
import { getAskPrescription, getMedicationPeriod } from '@/api/index'
import { optionsName } from '@/utils/index.js'
import { askDrugPackCount } from '@/utils/utils.js'
export default {
    data() {
        return {
            submit: true,
            loading: true,
            finished: false,
            detail: {},
            medicationPeriod: []
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        askDrugPackCount,
        optionsName,
        init() {
            getMedicationPeriod().then(({ code, data }) => {
                if (code == 0) {
                    this.medicationPeriod = data.list;
                    this.onDataGet()
                } else {
                    this.loading = false;
                }
            }).catch(() => {
                this.loading = false;
            })
        },
        onDataGet() {
            this.loading = true;
            getAskPrescription({
                askNo: this.$route.query.askNo
            }).then(({ code, data }) => {
                if (code == 0) {
                    this.detail = data || {};
                    this.loading = false;
                    this.finished = true;
                }
            }).catch(({ message }) => {
                this.loading = false;
            })
        },
        onDateTime(date) { // 时间格式
            if (date) {
                let time = new Date(date);
                let year = time.getFullYear();
                let month = time.getMonth() + 1;
                let day = time.getDate();
                return year + '-' + month + '-' + day;
            } else {
                return ''
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    background: #f2f2f2;

    &-body {
        padding: 10px;

        &-box {
            background: #fff;
            padding: 15px;
            border-radius: 6px;

            .scroll {
                height: calc(100vh - 154px - 48px);
                overflow-y: auto;
            }

            .header {
                &-box {
                    display: flex;
                    align-items: center;
                    font-weight: bold;
                    padding-top: 5px;

                    &::before {
                        content: "";
                        width: 3px;
                        height: 18px;
                        background: #0082ef;
                        border-radius: 5px;
                        margin-right: 8px;
                        margin-top: 1px;
                    }
                }
            }

            .form {
                &-item {
                    border-top: 1px solid #efefef;
                    padding-top: 20px;
                    margin-top: 10px;
                    font-size: 18px;

                    &-title {
                        font-weight: bold;
                        margin-bottom: 15px;
                        display: flex;
                        align-items: center;

                        &::before {
                            content: "";
                            width: 6px;
                            height: 6px;
                            border-radius: 4px;
                            background: #0082ef;
                            margin-right: 5px;
                            margin-top: 5px;
                        }
                    }

                    &-box {
                        display: flex;
                        flex-wrap: wrap;
                    }

                    .item {
                        // display: flex;
                        margin-bottom: 15px;
                        width: 100%;
                        line-height: 1.5;

                        &.nowrap {
                            white-space: nowrap;
                        }

                        .label,
                        .value {
                            display: inline;
                        }

                        .label {
                            color: #666;
                        }

                        .value {
                            margin-left: 10px;
                            word-break: break-all;
                        }
                    }

                    .itm {
                        margin-top: 20px;

                        &:first-child {
                            margin-top: 0;
                        }

                        &-head {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            font-size: 16px;

                            .name {
                                font-weight: bold;
                            }
                        }

                        &-foot {
                            display: flex;
                            justify-content: flex-end;
                            margin-top: 10px;
                            font-size: 16px;
                            color: #666;

                            .cell {
                                margin-left: 10px;
                            }
                        }
                    }
                }
            }
        }
    }

    &-btn {
        background: #fff;
        padding: 20px;
        margin-top: 10px;

        .van-button {
            width: 100%;
            border-radius: 6px;
        }
    }

    .total {
        margin-top: 20px;
        padding-right: 10px;
        text-align: right;
        font-weight: bold;

        .price {
            color: #f54739;
        }
    }
}</style>